import { makeStyles } from '@material-ui/core/styles';

import { HIGHLIGHT_MARK } from 'src/data/markedText';
import { COLORS } from 'src/data/ui';

export default makeStyles(
  () => ({
    root: {
      outline: 'none',

      '&$displayMarks': {
        [`& [data-mark="${HIGHLIGHT_MARK.recompose}"]`]: {
          color: COLORS.primary.active,
        },
      },

      [`& [data-decoration="${HIGHLIGHT_MARK.positive}"]`]: {
        backgroundColor: COLORS.success.light,
        borderBottom: `1.5px solid ${COLORS.success.default}`,
      },

      [`& [data-decoration="${HIGHLIGHT_MARK.warning}"]`]: {
        backgroundColor: COLORS.warning.light,
        borderBottom: `1.5px solid ${COLORS.warning.default}`,
      },
    },
    readOnly: {},
    displayMarks: {},
  }),
  { name: 'MarkedEditable' }
);
